import * as React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const FeatureHero = ({ children, image }) => {
  return (
    <section className="container-fluid feature-hero feature-hero--home mt-10 sm:mt-18 mb-10 md:mb-30">
      <div className="row middle-sm between-md center-xs start-sm">
        <div className="col-xs-12 col-sm-6 col-md-6 feature-hero__content">
          {children}
        </div>

        <div className="col-xs-12 col-sm-6 mt-10 sm:mt-0 mr-0 feature-hero__asset--static">
          <GatsbyImage
            image={getImage(image.src)}
            alt={image.alt}
            className="w-100"
          />
        </div>
      </div>
    </section>
  )
}

export default FeatureHero
